"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var lodash_1 = require("lodash");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importDefault(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var useTitle_1 = __importDefault(require("../../hooks/useTitle"));
var BudgetLinesTable_1 = require("./Components/BudgetLinesTable");
var react_router_dom_1 = require("react-router-dom");
function TemplateDesigner() {
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    var params = (0, react_router_dom_1.useParams)();
    var templateId = params.templateId;
    var budgetTemplateDocSnapshot = (0, firestore_1.useDocument)(collectionsRef_1.budgetTemplatesRef.doc(templateId))[0];
    var budgetLineSnapshot = (0, firestore_1.useCollection)(collectionsRef_1.budgetLinesRef.where("budgetSectionId", "==", templateId))[0];
    (0, useTitle_1.default)((_a = budgetTemplateDocSnapshot === null || budgetTemplateDocSnapshot === void 0 ? void 0 : budgetTemplateDocSnapshot.data()) === null || _a === void 0 ? void 0 : _a.title);
    if (!budgetTemplateDocSnapshot || !budgetLineSnapshot) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var description = ((budgetTemplateDocSnapshot === null || budgetTemplateDocSnapshot === void 0 ? void 0 : budgetTemplateDocSnapshot.data()) ||
        {}).description;
    var sortedBudgetLine = (0, lodash_1.sortBy)(budgetLineSnapshot.docs, function (item) {
        return item.data().createdAt.toDate();
    }).reverse();
    var budgetLines = sortedBudgetLine.map(function (e) {
        return __assign(__assign({}, e.data()), { id: e.id });
    });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.budgetBox }, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("h3", __assign({ style: {
                        background: "#40a9ff94",
                        padding: 20,
                        borderRadius: 4,
                        margin: -11,
                    } }, { children: [(0, jsx_runtime_1.jsx)("b", { style: { marginRight: "10px" } }), description, (0, jsx_runtime_1.jsx)("b", { style: { float: "right", margin: -9 } })] })) }), (0, jsx_runtime_1.jsx)("div", __assign({ className: index_modules_css_1.default.budgetTable }, { children: (0, jsx_runtime_1.jsx)(BudgetLinesTable_1.BudgetLineTable, { data: budgetLines, projectId: "template", code: "Template", budgetSectionId: templateId }) }))] })));
}
exports.default = TemplateDesigner;
